/* eslint-disable react/jsx-key */
import { createStyles, List, ListProps, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

export type L3MenuProps = ListProps;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    affixMenu: {
      position: 'fixed',
      // Enforce word wrapping based on breakpoint width on fixed L3
      // Does not yet account for expanded sidebar but resolves admin issues
      [theme.breakpoints.only('xl')]: {
        maxWidth: `calc(${theme.breakpoints.values.xl}px * .1666667)`, // 2 col grid is 16.66667% width
      },
      [theme.breakpoints.only('lg')]: {
        maxWidth: `calc(${theme.breakpoints.values.lg}px * .1666667)`, // 2 col grid is 16.66667% width
      },
      [theme.breakpoints.only('md')]: {
        maxWidth: `calc(${theme.breakpoints.values.md}px * .1666667)`, // 2 col grid is 16.66667% width
      },
    },
  }),
);
const L3NavMenu = ({ children, ...props }: L3MenuProps): JSX.Element => {
  const classes = useStyles();
  return (
    <List {...props} disablePadding={true} component="nav" role="nav" className={classes.affixMenu}>
      {children}
    </List>
  );
};

export default L3NavMenu;
